import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import type { ReactNode } from 'react'

export type SubmitButtonProps = {
    children: ReactNode
    submitting?: boolean
    disabled?: boolean
    variant?: string
    className?: string
}

export function SubmitButton({ children, submitting, disabled, variant = 'primary', className }: SubmitButtonProps) {
    return (
        <Button type="submit" variant={variant} disabled={submitting || disabled} className={`su-tappable ${className ?? ''}`}>
            {submitting && <Spinner as="span" animation="border" size="sm" className="me-2" />}
            {children}
        </Button>
    )
}
